import { Link } from "@msuite/ui/link";
import { useTranslation } from "@msuite/ui/localization";
import type { Enums } from "@msuite/utils/types";

/** Props Interface */
interface BankAccountSourceCellProps {
	source: Enums<"contactBankAccountSource">;
	incomingInvoiceId: string | null;
}

/** Where an account came from: entered by hand, or read off an invoice — linked while it exists. */
export function BankAccountSourceCell({ source, incomingInvoiceId }: BankAccountSourceCellProps) {
	/** Context */
	const { t } = useTranslation();

	/** Render */
	const label = t(`contacts.bank_accounts.sources.${source}`);
	if (source === "invoice" && incomingInvoiceId) {
		return <Link href={`/controlling/incoming-invoices/${incomingInvoiceId}`}>{label}</Link>;
	}
	return label;
}
